module.exports = __webpack_public_path__ + "static/taegeun.moon-b3d2ed6a0b76793fe0ab8b14026630b1.jpeg";